export default "__VITE_ASSET__CYsE9ahQ__"